import { useDataLoader } from "2g-hooks/fetch";

import { DATA } from "b2b/api/paths";

export default function useProvozniInformaceSeznam(payload) {
  return useDataLoader({
    url: DATA.provozniInformaceSeznam(),
    method: "post",
    payload
  });
}
